import { call, put, takeEvery, takeLatest, takeLeading } from "redux-saga/effects";
import { types } from "../action-types";

import {
  fetchMessagesAPI,
  sendMessageAPI,
  getInboxMessagesAPi,
  fetchChatHistoryApi,
  MessageAttachmentAPi,
  makeOfferAPi,
  editOfferApi,
  getMsgsCountApi,
  getHRMSApi,
  fetchConversationCountAPI,
} from "../../API/API";

function* fetchMessagesSaga(action) {
  try {
    const { type, results, skip } = action.payload;
    const response = yield call(() => fetchMessagesAPI(type, results, skip));
    yield put({
      type: types.FETCH_MESSAGES_SUCCESS,
      payload: { data: response.data, type: type },
    });
  } catch (error) {
    yield put({ type: types.FETCH_MESSAGES_FAILURE, error });
  }
}

function* fetchConversationCountSaga(params) {
  try {
    // const {type, results, skip} = action.payload;
    const response = yield call(() => fetchConversationCountAPI(params.payload));
    yield put({
      type: types.GET_CONVERSATION_COUNT_SUCCESS,
      payload: { data: response.data},
    });
  } catch (error) {
    yield put({ type: types.GET_CONVERSATION_COUNT_FAILURE, error });
  }
}

function* fetchInboxMessagesSaga(params) {
  try {
    // const {type, results, skip} = action.payload;
    const response = yield call(() => getInboxMessagesAPi(params.payload));
    yield put({
      type: types.GET_MESSAGES_INBOX_SUCCESS,
      payload: { data: response.data, fetchMore: params?.payload?.fetchMore, fromSocket: params.payload.perPage == 1 ? true : false, pageNumber: params.payload.page},
    });
  } catch (error) {
    yield put({ type: types.GET_MESSAGES_INBOX_FAILURE, error });
  }
}

function* sendMessageSaga(action) {
  try {
    const { conversationId, recipientId, message, formData } = action.payload;
    const response = yield call(() =>
      sendMessageAPI(conversationId, recipientId, message, formData)
    );
    yield put({ type: types.SEND_MESSAGE_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.SEND_MESSAGE_FAILURE, error });
  }
}

function* getChatHistorySaga(action) {
  try {
    const { id } = action.payload;
    const response = yield call(() => fetchChatHistoryApi(id));
    let messages = response?.data?.data?.body;
    const cards = response?.data?.data?.cards;
    let id1,id2,sender,rec;
    if(cards && messages && messages.length){
      for (let index = 0; index < messages.length; index++) {
        id1 = messages[index].SenderProfileId;
        id2 = messages[index].RecipientProfileId;
        sender = cards?.userIds.findIndex((i) => i == id1);
        rec = cards?.userIds.findIndex((i) => i == id2);
        messages[index].SenderUser = cards?.users[sender];
        messages[index].RecipientUser = cards?.users[rec];
        if (messages[index].Status) {
          messages[index].BidCard =
            cards?.msg?.SourceTypeId == 1 ? cards?.bid : null;
          messages[index].ProposalCard =
            cards?.msg?.SourceTypeId == 2 ? cards?.bid : null;
          messages[index].SkillListingCard = cards?.SkillListingCard ?? null;
          messages[index].InterviewCard = cards?.InterviewCard ?? null;
          messages[index].OfferCard = cards?.bid?.offers ?? null;
          messages[index].Ratings =  cards?.bid.rating ?? null;
          messages[index].GigCard = cards?.GigCard ?? null;
        }
      }
    }
    yield put({ type: types.FETCH_CHAT_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_CHAT_FAILURE, error });
  }
}

function* postAttachmentSaga(action) {
  try {
    const response = yield call(() => MessageAttachmentAPi(action.payload));
    yield put({
      type: types.SEND_MESSAGE_ATTACHMENT_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: types.SEND_MESSAGE_ATTACHMENT_FAILURE, error });
  }
}

function* postOfferSaga(action) {
  try {
    const response = yield call(() => makeOfferAPi(action.payload));
    if (response) {
      action.payload.id.successCallBack()
    }
    yield put({ type: types.POST_OFFER_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.POST_OFFER_FAILURE, error });
  }
}

function* editOfferSaga(action) {
  try {
    const response = yield call(() => editOfferApi(action.payload));
    yield put({ type: types.EDIT_OFFER_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.EDIT_OFFER_FAILURE, error });
  }
}

function* getHrmsSaga(action) {
  try {
    const response = yield call(() => getHRMSApi());
    yield put({ type: types.GET_HRM_SUCCESS, payload: response.data , profile: action.payload});
  } catch (error) {
    yield put({ type: types.GET_HRM_FAILURE, error });
  }
}

function* getMsgsCountsSaga(action) {
  try {
    const response = yield call(() => getMsgsCountApi(action.payload));
    yield put({ type: types.GET_MESSAGES_COUNTS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.GET_MESSAGES_COUNTS_FAILURE, error });
  }
}

//old API Saga
export function* watchFetchMessagesSaga() {
  yield takeEvery(types.FETCH_MESSAGES_REQUESTED, fetchMessagesSaga);
}
export function* watchSendMessagesSaga() {
  yield takeEvery(types.SEND_MESSAGE_REQUESTED, sendMessageSaga);
}
//new api saga
export function* watchGetConversationCountSaga() {
  yield takeEvery(types.GET_CONVERSATION_COUNT_INIT, fetchConversationCountSaga);
}
export function* watchGetInboxMessagesSaga() {
  yield takeEvery(types.GET_MESSAGES_INBOX_REQUESTED, fetchInboxMessagesSaga);
}
export function* watchGetChatSaga() {
  yield takeEvery(types.FETCH_CHAT_REQUESTED, getChatHistorySaga);
}
export function* watchPostAttachmentSaga() {
  yield takeEvery(types.SEND_MESSAGE_ATTACHMENT_REQUESTED, postAttachmentSaga);
}
export function* watchMakeOfferSaga() {
  yield takeLeading(types.POST_OFFER_REQUESTED, postOfferSaga);
}
export function* watchEditOfferSaga() {
  yield takeLeading(types.EDIT_OFFER_REQUESTED, editOfferSaga);
}

export function* watchGetMsgsCountsSaga() {
  yield takeEvery(types.GET_MESSAGES_COUNTS_INIT, getMsgsCountsSaga);
}

export function* watchgetHrmsSaga() {
  yield takeEvery(types.GET_HRM_INIT, getHrmsSaga);
}